// extracted by mini-css-extract-plugin
export default {"dropzone":"profile_dropzone__7LoPo","overlay":"profile_overlay__tF9D2"};